// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .info-box {
    position: fixed;       
    top: 20%;              
    right: 0;              
    width: 300px;         
    padding: 20px;         
    background-color: #f1f1f1;
    box-shadow: -2px 0 5px rgba(0, 0, 0, 0.1);
    border-left: 1px solid #ccc;
    border-radius: 8px 0 0 8px;
    z-index: 1000;
}
  
button {
    margin-top: 10px;
} */


.info-box {
  position:absolute;       
  top: 20%;             
  right: 15%;       
  width: 99%;      
  height:50%;   
  padding: 10px;         
  background-color: #f1f1f1;
  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.1);
  border-left: 1px solid #ccc;
  border-radius: 10px;
  overflow-y:scroll;
  z-index: 1000;
}


.info-header{
  display: grid;
  justify-content: space-between;
  align-items: center;
}

button {
  margin-top: 10px;
}`, "",{"version":3,"sources":["webpack://./src/css/infoform.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;GAeG;;;AAGH;EACE,iBAAiB;EACjB,QAAQ;EACR,UAAU;EACV,UAAU;EACV,UAAU;EACV,aAAa;EACb,yBAAyB;EACzB,yCAAyC;EACzC,2BAA2B;EAC3B,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;AACf;;;AAGA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":["/* .info-box {\n    position: fixed;       \n    top: 20%;              \n    right: 0;              \n    width: 300px;         \n    padding: 20px;         \n    background-color: #f1f1f1;\n    box-shadow: -2px 0 5px rgba(0, 0, 0, 0.1);\n    border-left: 1px solid #ccc;\n    border-radius: 8px 0 0 8px;\n    z-index: 1000;\n}\n  \nbutton {\n    margin-top: 10px;\n} */\n\n\n.info-box {\n  position:absolute;       \n  top: 20%;             \n  right: 15%;       \n  width: 99%;      \n  height:50%;   \n  padding: 10px;         \n  background-color: #f1f1f1;\n  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.1);\n  border-left: 1px solid #ccc;\n  border-radius: 10px;\n  overflow-y:scroll;\n  z-index: 1000;\n}\n\n\n.info-header{\n  display: grid;\n  justify-content: space-between;\n  align-items: center;\n}\n\nbutton {\n  margin-top: 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
